import React, { Component } from 'react';
import logoPS from '../../assets/logo-ps-w.png';
import '../../inc/genstyle.css';
import '../iinc/iStyle.css';
import Avatar from '@mui/material/Avatar';
import LogoutIcon  from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';

class IHeader extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userFullname: '',
        userPicture: '',
        userPosition: '',
        notifCount: 0
      };
      this.handleClick = this.handleClick.bind(this);
      this.handleLoad = this.handleLoad.bind(this);
    }
    
    handleClick(ln) {    
        if(ln==='logout') {
            localStorage.clear();
            alert('User signed out.');
            window.location.href = global.config.urlOrigin;
        }
    }

    handleLoad() {
        try{
            var userPosition = "Staf", userFullName ="", userPicture="";
            if(localStorage.getItem('uposition') !== '') { userPosition = localStorage.getItem('uposition'); }
            if(localStorage.getItem('ufullname') !== '') { userFullName = localStorage.getItem('ufullname'); }
            if(localStorage.getItem('upicture') !== '' && localStorage.getItem('upicture') !== null) { userPicture = localStorage.getItem('upicture'); }
            this.setState({
                userFullname: userFullName,
                userPicture: userPicture,
                userPosition: userPosition,
            });

        } catch (e) {
            console.log(e);
            localStorage.clear();
        }
    }

    componentDidMount() {
        this.handleLoad();
    }
    render() { 
      return (
           <div className="flex-container">
               <div className="flex-container header-left">
                    <a href="/"><img src={logoPS} className="header-logo" alt="logo"/></a>
                    <div className="spacer"></div>
                    <div className="header-logo-t divCenter">Internal Portal</div>
               </div>
               <div className="header-menu divCenter">
                  <div className="mgR30 flex-container">
                    <div className="mgR20 divMiddle">
                    {(localStorage.getItem('ulevel') !== undefined && localStorage.getItem('ulevel') === global.config.userlevel[0])?
                        <div className="header-icon cursor-on flex-container divMiddle" onClick={() => this.handleClick('notif')}>
                            <NotificationsIcon size={21} className="iconDark" />
                        </div>: ''}
                    </div>
                    <div className="mgR30 flex-container header-profile">
                        <div className="mgR10">
                            <Avatar
                                alt={this.state.userFullname}
                                src={this.state.userPicture}
                                sx={{ width: 45, height: 45 }}
                            />
                        </div>
                        <div className="divMiddle">
                            <div className="textBold">{this.state.userFullname}</div>
                            <div>{this.state.userPosition}</div>
                        </div>
                        
                    </div>
                    <div className="divMiddle">
                        <div className="header-icon cursor-on divMiddle" onClick={() => this.handleClick('logout')}><LogoutIcon className="iconDark" size={22} /></div>
                    </div>
                  </div>
                   
               </div>
           </div>
       
      );
    }
   }
    
   export default IHeader;